import { Controller } from "@hotwired/stimulus";
import { buildUploadComponent, filesCountChangedEventName } from '../../scripts/fileUpload';
import { viewOrEditFormConnectedEventName } from "../ViewOrEditForm/ViewOrEditFormController";

export default class VideoEditorController extends Controller {
    static targets = [
        "videoUploader",
        "thumbnailUploader",
        "videosCount",
        "thumbnailsCount"
    ];

    readonly videoUploaderTarget!: HTMLElement;
    readonly thumbnailUploaderTarget!: HTMLElement;
    readonly videosCountTarget!: HTMLInputElement;
    readonly thumbnailsCountTarget!: HTMLInputElement;

    connect() {
        this.videoUploaderTarget.addEventListener(filesCountChangedEventName, this.onVideosCountChanged.bind(this), {});
        this.thumbnailUploaderTarget.addEventListener(filesCountChangedEventName, this.onThumbnailsCountChanged.bind(this), {});

        this.element.addEventListener(viewOrEditFormConnectedEventName, () => {
            buildUploadComponent($(this.videoUploaderTarget));
            buildUploadComponent($(this.thumbnailUploaderTarget));
        });
    }

    onVideosCountChanged(event: CustomEventInit) {
        const videosCount = event.detail as number;
        this.videosCountTarget.value = `${videosCount}`;

        this.refreshFormValidation();
    }

    onThumbnailsCountChanged(event: CustomEventInit) {
        const thumbnailsCount = event.detail as number;
        this.thumbnailsCountTarget.value = `${thumbnailsCount}`;

        this.refreshFormValidation();
    }

    refreshFormValidation() {
        const form = $("form", this.element);
        if (form) form.valid();
    }
}